export default __webpack_public_path__ + "static/media/youtube.986679c6.svg";